import { render, staticRenderFns } from "./TransactionListItem.vue?vue&type=template&id=2e1d1967&scoped=true&"
import script from "./TransactionListItem.vue?vue&type=script&lang=js&"
export * from "./TransactionListItem.vue?vue&type=script&lang=js&"
import style0 from "./TransactionListItem.vue?vue&type=style&index=0&id=2e1d1967&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1d1967",
  null
  
)

export default component.exports